import { useCallback } from "react";
import Box from "@mui/material/Box";
import Grid from "components/primitives/Grid";
import useAthlete from "hooks/useAthlete";
import moment from "moment";
import AthleteName from "components/AthleteName";
import { useNavigate } from "react-router-dom";
import ActiveIndicator from "components/ActiveIndicator";
import { useTranslation } from "react-i18next";
import { AthleteCardButton } from "./LiveActivityFeedVirtualTableRow.components";

function LiveActivityFeedVirtualTableRowAthleteLabel(props: { athleteId: string; completedDate: string }) {
  const { athleteId, completedDate } = props;

  const athlete = useAthlete(athleteId, true);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const updateLeaderboardExercise = useCallback(() => {
    navigate(`/athlete-hub/${athleteId}`);
  }, [athleteId, navigate]);

  const time = moment(completedDate);

  const isOnline = useCallback(() => {
    return moment().diff(time, "minutes") < 30;
  }, [time]);

  return (
    <Box sx={{ p: 0, pl: 2, pr: 2 }}>
      <Grid container alignItems="center" spacing="0px" p={0} pt={1} pb={0.5} sx={{ width: "100%" }}>
        <Grid size="grow" component={AthleteCardButton} onClick={updateLeaderboardExercise}>
          <ActiveIndicator
            title={t("global.online_label_text")}
            color="secondary"
            overlap="rectangular"
            variant={isOnline() ? "dot" : undefined}
            anchorOrigin={{ vertical: "top", horizontal: "left" }}
          >
            <AthleteName athlete={athlete} />
          </ActiveIndicator>
        </Grid>
        <Grid>
          <Box
            component="span"
            title={time.toLocaleString()}
            sx={{
              fontWeight: "fontWeightMedium",
              fontSize: 14,
            }}
          >
            {time.fromNow(false /* suffix */)}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default LiveActivityFeedVirtualTableRowAthleteLabel;
